// Shared config for the Source2Table marketing site.
// The waitlist/registration is served by the EXISTING Source2Table production
// backend. We only call its public Join endpoints — no new backend/DB here.
export const LOGO_SRC = "/logo.png";

// Internal route on this marketing site that hosts the Join experience.
export const JOIN_PATH = "/join";

// Existing Source2Table PRODUCTION API base (from env, never hardcoded in components).
export const S2T_API_URL = process.env.REACT_APP_S2T_API_URL;
